/** Bouton copier (presse-papiers). */
import { useState, type MouseEvent } from "react";
import "./copyButton.css";

type CopyButtonProps = {
  text: string;
  label?: string;
};

export function CopyButton({ text, label = "Copier" }: CopyButtonProps) {
  const [ok, setOk] = useState(false);
  const value = text.trim();
  if (value === "") return null;

  async function copy(e: MouseEvent) {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      const el = document.createElement("textarea");
      el.value = value;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setOk(true);
    window.setTimeout(() => setOk(false), 1200);
  }

  return (
    <button
      type="button"
      className={`fx-copy${ok ? " is-ok" : ""}`}
      title={ok ? "Copié" : label}
      aria-label={ok ? "Copié" : label}
      onClick={(e) => void copy(e)}
    >
      {ok ? (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M5 12.5 10 17.5 19 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <rect x="8.5" y="8.5" width="11" height="11" rx="1.8" stroke="currentColor" strokeWidth="1.7" />
          <path d="M6.5 15.5H5.8A1.8 1.8 0 0 1 4 13.7V5.8A1.8 1.8 0 0 1 5.8 4h7.9A1.8 1.8 0 0 1 15.5 5.8V6.5" stroke="currentColor" strokeWidth="1.7" />
        </svg>
      )}
    </button>
  );
}
